import { jwtDecode } from 'jwt-decode';

export const isTokenExpired = (payload: { exp?: number }) => {
	const exp = payload.exp ?? 0;

	return new Date().getTime() >= exp * 1000;
};

export const createAccessToken = (accessToken: string) => {
	try {
		if (!accessToken) {
			return null;
		}

		const accessPayload = jwtDecode(accessToken);

		return {
			token: accessToken,
			payload: accessPayload,
		};
	} catch {
		return null;
	}
};
